import * as React from "react";

export const SearchGlassSvg: React.SFC<{ className?: string }> = (props) => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 57" className={props.className || 'search-glass-svg'}>
    <path d="M55.1 51.9L41.6 37.8c3.5-4.1 5.4-9.4 5.4-14.8 0-12.7-10.3-23-23-23s-23 10.3-23 23 10.3 23 23 23c4.8 0 9.3-1.4 13.2-4.2l13.7 14.2c0.6 0.6 1.3 0.9 2.2 0.9 0.8 0 1.5-0.3 2.1-0.8C56.3 55 56.3 53.1 55.1 51.9zM24 6c9.4 0 17 7.6 17 17s-7.6 17-17 17 -17-7.6-17-17S14.6 6 24 6z" />
  </svg>

}